<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/pro-regular-svg-icons/faSync').definition,
  require('@fortawesome/pro-regular-svg-icons/faSearch').definition,
  require('@fortawesome/pro-regular-svg-icons/faSignOut').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleDown').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleLeft').definition,
  require('@fortawesome/pro-regular-svg-icons/faAngleRight').definition,
  require('@fortawesome/pro-regular-svg-icons/faBell').definition,
  require('@fortawesome/pro-regular-svg-icons/faEdit').definition,
  require('@fortawesome/pro-regular-svg-icons/faEye').definition,
  require('@fortawesome/pro-regular-svg-icons/faEyeSlash').definition,
  require('@fortawesome/pro-regular-svg-icons/faClipboardList').definition,
  require('@fortawesome/pro-regular-svg-icons/faTicketAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faPlus').definition,
  require('@fortawesome/pro-regular-svg-icons/faMinus').definition,
  require('@fortawesome/pro-regular-svg-icons/faInfoCircle').definition,
  require('@fortawesome/pro-regular-svg-icons/faTimes').definition,
  require('@fortawesome/pro-regular-svg-icons/faEllipsisV').definition,
  require('@fortawesome/pro-regular-svg-icons/faHistory').definition,
  // Main Menu
  require('@fortawesome/pro-regular-svg-icons/faBars').definition,
  require('@fortawesome/pro-regular-svg-icons/faTachometerAltFast').definition,
  require('@fortawesome/pro-regular-svg-icons/faGripHorizontal').definition,
  require('@fortawesome/pro-regular-svg-icons/faAnalytics').definition,
  require('@fortawesome/pro-regular-svg-icons/faUsersClass').definition,
  require('@fortawesome/pro-regular-svg-icons/faUserLock').definition,
  require('@fortawesome/pro-regular-svg-icons/faConciergeBell').definition,
  require('@fortawesome/pro-regular-svg-icons/faUser').definition,
  require('@fortawesome/pro-regular-svg-icons/faCog').definition,
  require('@fortawesome/pro-regular-svg-icons/faExclamationTriangle')
    .definition,
  require('@fortawesome/pro-regular-svg-icons/faAddressBook').definition,
  require('@fortawesome/pro-regular-svg-icons/faExternalLink').definition,
  require('@fortawesome/pro-regular-svg-icons/faImage').definition,
  require('@fortawesome/pro-regular-svg-icons/faCaretDown').definition,
  require('@fortawesome/pro-regular-svg-icons/faTag').definition,
  require('@fortawesome/pro-regular-svg-icons/faPiggyBank').definition,
  // Product Type
  require('@fortawesome/pro-regular-svg-icons/faIcons').definition,
  require('@fortawesome/pro-regular-svg-icons/faGraduationCap').definition,
  require('@fortawesome/pro-regular-svg-icons/faUtensils').definition,
  require('@fortawesome/pro-regular-svg-icons/faHeadset').definition,
  require('@fortawesome/pro-regular-svg-icons/faHandReceiving').definition,
  // Check in
  require('@fortawesome/pro-regular-svg-icons/faPhone').definition,
  require('@fortawesome/pro-regular-svg-icons/faBackspace').definition,
  require('@fortawesome/pro-regular-svg-icons/faCalendar').definition,
  // Dashboard
  require('@fortawesome/pro-regular-svg-icons/faTh').definition,
  require('@fortawesome/pro-regular-svg-icons/faFileInvoiceDollar').definition,
  require('@fortawesome/pro-regular-svg-icons/faFlag').definition,
  require('@fortawesome/pro-regular-svg-icons/faDollarSign').definition,
  require('@fortawesome/pro-regular-svg-icons/faCogs').definition,
  require('@fortawesome/pro-regular-svg-icons/faDonate').definition,
  // Order
  require('@fortawesome/pro-regular-svg-icons/faPaperPlane').definition,
  require('@fortawesome/pro-regular-svg-icons/faShareAlt').definition,
  require('@fortawesome/pro-regular-svg-icons/faBan').definition,
  require('@fortawesome/pro-regular-svg-icons/faCopy').definition,
  require('@fortawesome/free-brands-svg-icons/faFacebookF').definition,
  require('@fortawesome/free-brands-svg-icons/faLine').definition,
  require('@fortawesome/pro-regular-svg-icons/faSms').definition,
  require('@fortawesome/pro-regular-svg-icons/faCommentDots').definition,
  require('@fortawesome/pro-regular-svg-icons/faEnvelope').definition,
  require('@fortawesome/pro-regular-svg-icons/faFileExport').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  // Product
  require('@fortawesome/pro-regular-svg-icons/faCheck').definition,
  require('@fortawesome/pro-regular-svg-icons/faTrashAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faGripVertical').definition,
  require('@fortawesome/pro-regular-svg-icons/faClipboardList').definition,
  require('@fortawesome/pro-regular-svg-icons/faTimes').definition,
  require('@fortawesome/pro-regular-svg-icons/faSearch').definition,
  // Filter
  require('@fortawesome/pro-regular-svg-icons/faFilter').definition,
  // User Permission
  require('@fortawesome/pro-regular-svg-icons/faCheckCircle').definition,
  require('@fortawesome/pro-regular-svg-icons/faInfo').definition,
  // Loading icon
  require('@fortawesome/pro-regular-svg-icons/faSpinner').definition,
  require('@fortawesome/pro-regular-svg-icons/faQuestionCircle').definition,
  // Merchant
  require('@fortawesome/pro-regular-svg-icons/faFileInvoice').definition,
  // Subscription
  require('@fortawesome/pro-regular-svg-icons/faPencilAlt').definition,
  require('@fortawesome/free-brands-svg-icons/faCcAmex').definition,
  require('@fortawesome/free-brands-svg-icons/faCcDinersClub').definition,
  require('@fortawesome/free-brands-svg-icons/faCcJcb').definition,
  require('@fortawesome/free-brands-svg-icons/faCcMastercard').definition,
  require('@fortawesome/free-brands-svg-icons/faCcPaypal').definition,
  require('@fortawesome/free-brands-svg-icons/faCcVisa').definition,
  // Member
  require('@fortawesome/pro-regular-svg-icons/faMailBulk').definition,
  require('@fortawesome/pro-regular-svg-icons/faTags').definition
)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: 'font-awesome',
    },
    name: {
      type: String,
      required: true,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    iconStyle: {
      type: String,
      default: 'far',
    },
    spin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="[iconStyle, name]"
    :class="$style.fontAwesome"
    :spin="spin"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
  />
</template>
<style lang="scss" module>
@import '@design';
.fontAwesome:global(.svg-inline--fa) {
  width: 1em;
  + span {
    margin-left: 0.5em;
  }
}
</style>
